import React, {
  useEffect,
  useState,
  createRef,
  useCallback,
  useRef,
} from "react";
import { useDropzone } from "react-dropzone";
import Thumbnail from "./Thumbnail";
import "./UploadIMG.css";
import "../swalStyle/customStyle.css";

const dropzoneRef = createRef();
const openDialog = () => {
  // Note that the ref is set async,
  // so it might be null at some point
  if (dropzoneRef.current) {
    dropzoneRef.current.open();
  }
};

function UploadIMG(props) {
  const Swal = require("sweetalert2");
  const imgCount = useRef(0);
  const [images, setImages] = useState([]);
  const [isImageFull, setIsImageFull] = useState(false);

  let imgBoxs = useRef([]);
  let isboxInit = useRef(false);
  if (!isboxInit.current) {
    for (let i = 0; i < props.limit; i++) {
      imgBoxs.current.push("box");
      isboxInit.current = true;
    }
  }
  const [errorMessage, setErrorMessage] = useState("");
  var imgindex = useRef(0);
  const onDrop = useCallback((acceptedFiles) => {

    handleFiles(acceptedFiles);
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
  });

  useEffect(() => {
    if(props.images){
      if(props.images.length>0)
      {
   
        handleFiles(props.images);
      }
    }
  }, [props.images])

  const removeFile = (id) => {
    const removeimageIndex = images.findIndex((e) => e.id === id);
    if (removeimageIndex !== -1) {
      imgCount.current--;
      images.splice(removeimageIndex, 1);
      // update unsupportedFiles array
      setImages([...images]);

      imgBoxs.current.push("box");
      setIsImageFull(false);
    }
  };

  const thumbs = images.map((file, index) => (
    <Thumbnail key={index} file={file} removeFile={removeFile} />
  ));
 
  const handleFiles = (files) => {
 
                
    if(files){
      if(!files[0].file && !files[0].path){
        return
      }
    }
       
    if (!props.limit) {
      props.limit = 1;
    }

    let filesArray = [...images];

    let errormsg = "";
    let slots = 0;
    slots = props.limit - imgCount.current;
    if (files.length <= slots) {
      slots = files.length;
    }

    if (slots + imgCount.current >= props.limit) {
      setIsImageFull(true);
    } else {
      setIsImageFull(false);
    }

    for (let i = 0; i < slots; i++) {
      if (validateFile(files[i]) && files[i].size <= 1024 * 1024 * 5) {
        imgCount.current++;

        filesArray.push(files[i]);
        imgBoxs.current.pop();
      } else {
        // add a new property called invalid
        setIsImageFull(false);
        files[i]["invalid"] = true;
        if (files[i].size > 1024 * 1024 * 5) {
          errormsg += files[i].name + props.txtDetail;
          setErrorMessage(files[i].name + props.txtDetail);
        } else {
          errormsg += files[i].name + props.txtDetail;
          setErrorMessage(files[i].name + props.txtDetail);
        }
      }
      if (errormsg !== "") {
        Swal.fire({
          iconHtml: '<img src="https://img2.pic.in.th/pic/Group-2966.png">',
          title: "Failed to upload.",
          html: 'Please correct format and try again.',
          confirmButtonText: "CLOSE",
        });
      }
    }
    try{
    filesArray.map((file) => {
      const reader = new FileReader();

      reader.onload = function (e) {

        setImages((prevState) => [
          ...prevState,
          {
            id: imgindex.current++,
            src: e.target.result,
            file: file,
          },
        ]);
      };
      if(file?.file)
      {
        reader.readAsDataURL(file?.file);
      }
      else if(file){
        reader.readAsDataURL(file);
      }
      return file;
    });
    }
    catch(err){
      console.log(err)
    }

    return filesArray.length;
  };

  const validateFile = (file) => {
    const validTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (validTypes.indexOf(file.type) === -1) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    props.onSelectedImages(images);
    return () => images.forEach((file) => URL.revokeObjectURL(file.src));
  }, [images]);

  return (
    <section className="upload fontReg font-size09">
      <div className="row w-100">
        <div
          className={`col-12 align-items-center ${props.limit >= 5 ? 'col-md-6' : 'col-md-10'} ${isImageFull ? "d-none" : "d-flex"} `}
        >
          <div
            {...getRootProps({ className: `'dropzone' card-upload` })}
            //onDrop={fileDrop}
          >
            <input {...getInputProps()} />
            <p className="mb-0">Upload File</p>
            <button type="button" className="btn-upload" onClick={openDialog}>
              Choose File
            </button>
            <span
              className='fontReg'
              >
              {props.txtDetail}
            </span>
          </div>
        </div>
        <div className={`col-12 ${props.limit >= 5 ? 'col-md-12 px-3' : 'col-md-2 px-0'} mt-4 mt-md-0`}>
          <aside className={`thumbsContainer ${props.limit >= 5 ? 'mt-3' : 'mt-0'}`}>
            {thumbs}
            {imgBoxs.current.map((count, index) => {
              return (
                <div className={`boxthumb ${props.limit >= 5 ? 'mt-3' : 'mt-0'}`} key={index}>
                  <span className="countimg">
                    {/* {index + 1 + "/" + props.limit} */}
                    {imgCount.current + "/" + props.limit}
                  </span>
                </div>
              );
            })}
          </aside>
        </div>
      </div>
    </section>
  );
}

export default UploadIMG;